import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import type { Tenant } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { isAuthorizationFailure } from 'src/utils/errors/isAuthorizationFailure';

interface GetTenantsResponse {
  success: boolean;
  tenants: Tenant[];
}

/**
 * Simple version of getTenants that doesn't require TanStack Query context
 * Used for direct calls from stores and utilities
 */
const getTenantsSimple = async (): Promise<GetTenantsResponse> => {
  if (isMockServices()) return await mock(_mockData);

  try {
    const authTokenHttp = await getCompatibleAuthTokenHttp();
    const response = await authTokenHttp<GetTenantsResponse>(
      '/shared/tenants',
      {
        method: 'GET',
      },
    );
    if (response.data) return response.data;
    throw new Error('Failed to fetch tenants');
  } catch (error) {
    if (isAuthorizationFailure(error)) {
      throw error;
    }

    console.error('Failed to fetch tenants:', error);
    // Fallback to mock data if API fails
    return await mock(_mockData);
  }
};

export default getTenantsSimple;

const _mockData: GetTenantsResponse = {
  success: true,
  tenants: [
    {
      id: 'tenant_1',
      createdAt: '2025-03-24T22:03:10.669Z',
      name: 'Default Tenant',
      schema: 'tenant_schema_default',
      status: 'active',
      updatedAt: '2025-03-24T22:03:10.669Z',
      configuration: {
        magicLinkAuth: {
          enabled: false,
        },
      },
    },
    {
      id: 'tenant_2',
      createdAt: '2025-03-24T22:03:10.669Z',
      name: 'Test Tenant',
      schema: 'tenant_schema_test',
      status: 'active',
      updatedAt: '2025-03-24T22:03:10.669Z',
      configuration: {
        magicLinkAuth: {
          enabled: false,
        },
      },
    },
  ],
};
